import { css } from '@emotion/css';
import { m, mobileMediaQuery, p3Css } from '@snapchat/snap-design-system-marketing';

export const searchContainerCss = css`
  margin-block: ${m('--spacing-xl')};
  margin-inline: auto;
  max-width: ${m('--search-container-max-width')};
  padding-inline: ${m('--spacing-xl')};
  width: 100%;

  ${mobileMediaQuery} {
    margin-block: ${m('--spacing-xxxl')};
  }
`;

export const searchAutocompleteCss = css`
  margin-block-end: ${m('--spacing-xxxl')};

  ${mobileMediaQuery} {
    margin-block-end: ${m('--spacing-xl')};
  }
`;

export const searchSubtitleCss = css`
  ${p3Css};
  color: ${m('--search-subtitle-color')};
  margin-block-start: ${m('--spacing-s')};
`;

export const searchResultsContainerCss = css`
  margin-block-end: ${m('--spacing-xxxl')};

  ${mobileMediaQuery} {
    margin-block-end: ${m('--spacing-xl')};
  }
`;

export const searchResultsListCss = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${m('--search-results-list-gap')};
  list-style: none;
`;

export const spinnerContainerCss = css`
  display: flex;
  justify-content: center;
`;
